import { addClassification, editClassification } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      dataFrom: {
        name: '',
        sort: ''
      }
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('名称'),
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: this.$t('请输入') + this.$t('排序'),
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    init(data) {
      if (data.id) {
        this.dataFrom = {
          name: data.name,
          sort: data.sort,
          classificationId: data.classificationId
        };
      }
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let fun = this.dataFrom.classificationId ? editClassification : addClassification;
          fun(this.dataFrom).then(res => {
            this.$message.success(this.$t('操作成功') + '!');
            this.$emit('ok');
            this.$emit('cancel');
          });
        }
      });
    }
  }
};